module.exports = __webpack_public_path__ + "img/tile.259743a6.png";